export default "__VITE_ASSET__CplFSn3___"